// extracted by mini-css-extract-plugin
export default {"scrollable":"scrollable_scrollable__sv6xW"};